import { FirebaseApp, initializeApp } from 'firebase/app';

async function firebaseInit(): Promise<FirebaseApp> {
  const resp = await fetch('/__/firebase/init.json');
  const initData = await resp.json();
  return initializeApp(initData);
}

const app = firebaseInit();

export default app;
